const community = localStorage.getItem("community");

export const communityURL =
  community === "my"
    ? "https://www.instagram.com/channel/AbYfkl2aJ0Y8y808/"
    : community === "tw"
      ? "https://line.me/ti/g2/0P-QxB04q_ombtXadXrtEUndiwjRkdOINPVX3g?utm_source=invitation&utm_medium=link_copy&utm_campaign=default"
      : community === "id"
        ? "https://www.instagram.com/sotravel_id"
        : "https://t.me/sotravel_sg";

export const instagramURL =
  community === "my"
    ? "https://www.instagram.com/sotravel_sg"
    : community === "tw"
      ? "https://www.instagram.com/sotravel_asia"
      : community === "id"
        ? "https://www.instagram.com/sotravel_id"
        : "https://www.instagram.com/sotravel_sg";

const resolveBaseURL = () => {
  // In development, choose between NGROK and BASE URL depending on whether the app is running in-app
  if (process.env.NODE_ENV === "development") {
    // When REACT_APP_USE_DEV_PROXY=true, axios uses relative URLs so the CRA
    // dev server (see src/setupProxy.js) forwards /v1/* to the backend with
    // changeOrigin — sidestepping CORS when pointing at the prod API.
    if (process.env.REACT_APP_USE_DEV_PROXY === "true" && !window.isInApp) {
      return "";
    }

    const defaultDevBase = "http://localhost:8080";

    if (typeof window !== "undefined" && window.isInApp) {
      return (
        process.env.REACT_APP_NGROK_BASE_URL || process.env.REACT_APP_BASE_URL || defaultDevBase
      );
    }

    return process.env.REACT_APP_BASE_URL || defaultDevBase;
  }

  // Production / non-development fallback
  return process.env.REACT_APP_BASE_URL || "https://api.sotravel.me/";
};

export const baseURL = resolveBaseURL();

export const isProd = process.env.NODE_ENV === "production";

export const telegramBotUsername = isProd
  ? "sotravel_bot"
  : process.env.REACT_APP_TELEGRAM_BOT_USERNAME;

export const telegramSupport = "https://t.me/sotravel_official";
export const whatsappSupport = "https://api.whatsapp.com/send?phone=6580893852";
export const lineSupport = "https://line.me/R/ti/p/@sotraveltw";
export const wechatSupport = "avider_666";

export const FIREBASE_AUTH_TOKEN_KEY = "FIREBASE_AUTH_TOKEN";

export const seoDescription = "Adventures that last a lifetime";

export const contactUsURL =
  community === "sg" ? telegramSupport : community === "tw" ? lineSupport : whatsappSupport;

export const communityLandingVideoDesktop =
  community === "my"
    ? "https://d1puf2nnbcyl9q.cloudfront.net/avider_landing_website_desktop.mov"
    : "https://d1puf2nnbcyl9q.cloudfront.net/desktop_landing.mp4";

export const communityLandingVideoMobile =
  community === "my"
    ? "https://d1puf2nnbcyl9q.cloudfront.net/avider_landing_website_mobile.mov"
    : "https://d1puf2nnbcyl9q.cloudfront.net/mobile_landing.mov";

export const landingVideoDesktop =
  community === "my"
    ? "https://d1puf2nnbcyl9q.cloudfront.net/avider_landing_website_desktop.mov"
    : "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/727154120250714-145539.mp4";

export const landingVideoMobile =
  community === "my"
    ? "https://d1puf2nnbcyl9q.cloudfront.net/avider_landing_website_mobile.mov"
    : "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/727154120250714-145539.mp4";

export const landingImageDesktop =
  community === "my"
    ? "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/9061564image_2025-05-12_21-28-06.png"
    : "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/937079image_2025-09-03_21-45-21.png";

export const landingImageMobile =
  community === "my"
    ? "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/2550419image_2025-05-12_21-28-20.png"
    : "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/178840photo_2024-09-17_19-31-17%20%283%29.jpg";

export const countryWithLandingPage = [
  "weekend",
  "beginner-leader-trips",
  "powderpuff-sale",
  "world-wonders",
  "europe",
  "rewrite-summer",
];

// Landing pages that moved to the guides app (/guides/*, served outside this
// SPA through an Amplify rewrite). Amplify redirects direct visits; these routes
// catch in-app navigations (home banners, <Link>s) that never reach the server.
// The short links open the destination booking pages, not the SEO guides.
export const LEGACY_GUIDE_REDIRECTS = {
  "/mongolia": "/guides/mongolia-trips",
  "/japow": "/guides/japow-trips",
};

export const defaultBroadCategories = (community) => {
  return {
    land: true,
    sea: true,
    snow: true,
    360: true,
    club: true,
  };
};

export const featuredCountries = [
  [
    "Mongolia",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQk6dMDS7FR-Cwai5Qn2cqfec-rK7gDVuSSJg&s",
    "mongolia",
    4,
  ],
  [
    "Indonesia",
    "https://www.barcelo.com/guia-turismo/wp-content/uploads/2022/10/yakarta-monte-bromo-pal.jpg",
    "indonesia",
    10,
  ],
  [
    "China",
    "https://www.thebrighterside.news/uploads/2025/02/great-wall.webp?auto=webp",
    "china",
    10,
  ],
  [
    "Japan",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTu0hqG7n3jWttWI-iMJfsjRWcrEsOOgSD2dg&s",
    "japan",
    3,
  ],
  [
    "Nepal",
    "https://assets.cntraveller.in/photos/6621101e437714505a7ebe56/16:9/w_1280,c_limit/GettyImages-1439040510.jpg",
    "nepal",
    3,
  ],
];

export const featuredRegions = [
  [
    "asia",
    "https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?w=400&h=260&fit=crop",
    "region_asia",
  ],
  [
    "africa",
    "https://d1puf2nnbcyl9q.cloudfront.net/d6133c060f2ad08a50fe1b74026a43bc-xl",
    "region_africa",
  ],
  [
    "europe",
    "https://t3.ftcdn.net/jpg/02/72/30/50/360_F_272305072_Na4NBF1qRybDU7d1mgbViiRgJkcC2adG.jpg",
    "region_europe",
  ],
  [
    "america",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRu1Ny8FHT8nPkDZUVfJLIMkcPbA-PcB9Ttaw&s",
    "region_america",
  ],
  [
    "antarctica",
    "https://sp-ao.shortpixel.ai/client/to_auto,q_lossy,ret_img,w_1024,h_576/https://www.swoop-antarctica.com/blog/wp-content/uploads/2024/02/Peninsula-1024x576.jpg",
    "region_antarctica",
  ],
];
